import FormModal from "../../../components/FormModal/FormModal";
import SelectInput from "../../../components/SelectInput/SelectInput";
import TextInput from "../../../components/TextInput/TextInput";
import FieldLabel from "../../../components/FieldLabel/FieldLabel";
import Buttons from "../../../components/Buttons/Buttons";
import { APP_PLATFORM_OPTIONS } from "../../../utils/appPlatform";

const AppVersionFormModal = ({
  open,
  onClose,
  addForm,
  errors,
  onChange,
  onSubmit,
  isSubmitting,
}) => (
  <FormModal
    open={open}
    onClose={onClose}
    title="Add New App Version"
    actions={
      <>
        <Buttons text="Cancel" variant="secondary" onClick={onClose} />
        <Buttons
          text="Save"
          variant="primary"
          onClick={onSubmit}
          disabled={isSubmitting}
        />
      </>
    }
  >
    <div className="add-device-form-container">
      <div className="add-device-form-field">
        <FieldLabel>Platform*</FieldLabel>
        <SelectInput
          name="platform"
          value={addForm.platform}
          onChange={onChange}
          options={APP_PLATFORM_OPTIONS}
          placeholder="Select Platform"
        />
        {errors.platform && <span className="error">{errors.platform}</span>}
      </div>

      <div className="add-device-form-field">
        <TextInput
          title="Release Notes*"
          name="releaseNotes"
          value={addForm.releaseNotes}
          onChange={onChange}
          placeholder="What's new in this release?"
          multiline
          rows={4}
          error={!!errors.releaseNotes}
          helperText={errors.releaseNotes}
        />
      </div>

      <p className="app-versions-hint">
        The next version number is generated automatically (e.g. 1.0.0 → 1.0.1).
      </p>
    </div>
  </FormModal>
);

export default AppVersionFormModal;
